module.exports = __webpack_public_path__ + "static/media/XMARK-BUSD.c5836a56.svg";